<script setup>
import { ref } from "vue";
import DatePicker from "@/components/form/DatePicker.vue";

const DEBOUNCE_MS = 400;

const props = defineProps({
    filterId:   { type: String, required: true },
    label:      { type: String, required: true },
    modelValue: { type: Object, default: () => ({ from: null, to: null }) },
});

const emit = defineEmits(["update:modelValue"]);

const localFrom = ref(props.modelValue.from ?? "");
const localTo   = ref(props.modelValue.to   ?? "");

const makeDebounced = (field) => {
    let timer;
    return (event) => {
        const raw = event.target.value;
        if (field === "from") localFrom.value = raw;
        else localTo.value = raw;

        clearTimeout(timer);
        timer = setTimeout(() => {
            emit("update:modelValue", {
                from: localFrom.value === "" ? null : Number(localFrom.value),
                to:   localTo.value   === "" ? null : Number(localTo.value),
            });
        }, DEBOUNCE_MS);
    };
};

const onFromInput = makeDebounced("from");
const onToInput   = makeDebounced("to");

const clear = () => {
    localFrom.value = "";
    localTo.value   = "";
    emit("update:modelValue", { from: null, to: null });
};

defineExpose({ clear });
</script>

<template>
    <div>
        <b-field :label="label" custom-class="mb-3">
            <b-input :id="`${filterId}_from`"
                     type="number"
                     :value="localFrom"
                     :placeholder="$t('filters.from')"
                     @input="onFromInput"/>
        </b-field>
        <b-field custom-class="mb-3">
            <b-input :id="`${filterId}_to`"
                     type="number"
                     :value="localTo"
                     :placeholder="$t('filters.to')"
                     @input="onToInput"/>
        </b-field>
    </div>
</template>
